import React, { useEffect } from 'react';
import { MessageHistoryDropdownContainer, MessageHistoryItem } from './styles';
import { ChatMessage } from 'models/chatbot';

interface MessageHistoryDropdownProps {
  messages: ChatMessage[];
  onSelect: (message: ChatMessage) => void;
  onClose: () => void;
  selectedIndex: number;
}

const MessageHistoryDropdown: React.FC<MessageHistoryDropdownProps> = ({
  messages,
  onSelect,
  onClose,
  selectedIndex,
}) => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if (target instanceof Element && !target.closest('.message-history-dropdown')) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <MessageHistoryDropdownContainer className="message-history-dropdown">
      {messages.map((message, index) => (
        <MessageHistoryItem key={index} onClick={() => onSelect(message)} isActive={index === selectedIndex}>
          {message.question}
        </MessageHistoryItem>
      ))}
    </MessageHistoryDropdownContainer>
  );
};

export default MessageHistoryDropdown;
